import React, { useCallback } from "react";
import FileBrowser from "./FileBrowser";
import SSHService from "../../../service/sshService";
import { useParams } from "react-router-dom";

export default function SSHFileBrowser(props) {
  const { Workspace_id } = useParams();

  let { pathStr } = props;
  let pref = "/";
  let fileName = [];

  // Split files with ",/" and create filename array for files and decide prefix
  const pathArr = pathStr?.split(",/");

  const tempPathArr = [];
  if (pathArr?.length) {
    pathArr.forEach((path, key) => {
      //Adding or removing extra '/' and making complete prefix
      if (path === "/") path = "";

      if (path) {
        if (path.startsWith("/")) path = path.substring(1);
        if (path.endsWith("/")) path = path.substring(0, path.length - 1);
        fileName.push(path);

        if (!path.endsWith("/")) path = path.replace(fileName[key].split("/").pop(), "");

        if (path === "/") path = "";

        if (key === 0 && path) {
          if (pref) {
            pref = pref + path;
          } else if (path[0] === "/") pref = path;
          else pref = "/" + path;
        }
        tempPathArr.push("/" + path);
      }
    });
  }

  // Check is files are selected from more than one folders then SFTP Browser will open with "root" directory with Error message
  let uniquepathArr = [...new Set(tempPathArr)];
  if (uniquepathArr.length > 1) pref = "/";

  //Getting file and folder data
  const getData = useCallback(async ({ prefix, Stage_id }) => {
    const ssh = new SSHService();
    return await ssh.getData({
      location: prefix,
      Stage_id,
    });
  }, []);

  //Download click
  const downloadClick = async ({ id, Stage_id }) => {
    const ssh = new SSHService();
    ssh.download(Workspace_id, {
      location: id,
      Stage_id,
    });
  };

  //Download button click
  const multipleDownload = ({ name, files, Stage_id }) => {
    const ssh = new SSHService();
    ssh.download(Workspace_id, {
      location: name,
      Stage_id,
      files,
    });
  };

  //Delete click
  const deleteClick = async ({ id, Stage_id, type }) => {
    const ssh = new SSHService();
    return await ssh.delete({
      location: id,
      Stage_id,
      type,
    });
  };

  //Delete Button click (Multiple files)
  const multipleDelete = async ({ name, Stage_id, type, files }) => {
    const ssh = new SSHService();
    return await ssh.delete({
      location: name,
      Stage_id,
      type,
      files,
    });
  };

  //Create Folder
  const createFolderClick = async ({ name, Stage_id }) => {
    const ssh = new SSHService();
    return await ssh.createFolder({
      location: name,
      Stage_id,
    });
  };

  return (
    <FileBrowser
      getData={getData}
      createFolderClick={createFolderClick}
      deleteClick={deleteClick}
      multipleDownload={multipleDownload}
      multipleDelete={multipleDelete}
      downloadClick={downloadClick}
      pref={pref}
      fileName={fileName?.join(",/")}
      {...props}
      url="root"
      type="sftp"
      title="SFTP Explorer"
    />
  );
}
